const base = '/virtual-classroom'
const manager = `${base}/manager`
const events = `${manager}/events`

const routes = {
  root: base,
  manager,
  events,
}

export default routes
